$( window ).on("load", function() {
    if ($('.boost-pfs-filter-product-item-inner  > .lux_swatch_under_price')) {
      $('.boost-pfs-filter-product-item-grid').addClass('luxreaders-boost-pfs-filter-product-item-grid')
    }
    else{
        if ($('.boost-pfs-filter-product-item-grid').hasClass('luxreaders-boost-pfs-filter-product-item-grid')) {
          $('.boost-pfs-filter-product-item-grid').removeClass('luxreaders-boost-pfs-filter-product-item-grid')
        }
    }
});